/*
# =============================================================================
# COMPLETE THE SET / LINKED PRODUCTS — BUNDLED SCRIPT (+ main-color → linked sync)
# - New bit:
#   * Detect main product color
#   * Apply to each linked-product card (select that color, hide other colors)
# =============================================================================
*/
(function () {
  const SEL = {
    panel: ".complete-the-set-wrapper",
    openBtn: ".complete-the-set-button",
    closeBtn: ".complete-the-set-wrapper .close",
    card: "article.linked-product[data-linked-item]",
    form: "[data-variant-form]",
    atc: "[data-atc]",
    select: "[data-variant-select]",
    qty: "[data-qty-input]",
    price: "[data-price]",
    variantsJSON: "[data-variants-json]",
    styleWithLink: ".style-with__link",
    sizeFieldset: 'fieldset.variant-input-wrap[name="Size"]',

    // NEW — main product form + its color fieldset (heuristics similar to cards)
    mainForm: "form.product-single__form",
    mainColorFieldsets:
      'fieldset.variant-input-wrap[name="Color"], fieldset[name="Colour"], .swatch--color, [data-color-swatch], .variant-wrapper--color'
  };

  document.addEventListener("DOMContentLoaded", () => {
    const panel    = document.querySelector(SEL.panel);
    const openBtn  = document.querySelector(SEL.openBtn);
    const closeBtn = document.querySelector(SEL.closeBtn);
    if (!panel || !openBtn || !closeBtn) return;

    // ---------------- Panel + Style-With filter ----------------
    function getActiveHandle() {
      const active = document.querySelector(SEL.styleWithLink + ".active");
      return active ? active.dataset.product : null;
    }
    function filterCardsByActive() {
      const activeHandle = getActiveHandle();
      panel.querySelectorAll(SEL.card + ".meta").forEach(card => {
        const handle = card.getAttribute("data-product");
        card.style.display = (activeHandle && handle === activeHandle) ? "" : "none";
      });
    }

    openBtn.addEventListener("click", (e) => { e.preventDefault(); panel.classList.add("active"); filterCardsByActive(); });
    closeBtn.addEventListener("click", (e) => { e.preventDefault(); panel.classList.remove("active"); });
    document.addEventListener("click", (e) => {
      if (!panel.classList.contains("active")) return;
      if (!panel.contains(e.target) && !openBtn.contains(e.target)) panel.classList.remove("active");
    });

    document.addEventListener("click", (e) => {
      const link = e.target.closest(SEL.styleWithLink);
      if (!link) return;
      document.querySelectorAll(SEL.styleWithLink).forEach(a => a.classList.remove("active"));
      link.classList.add("active");
      if (panel.classList.contains("active")) filterCardsByActive();
    });

    // ---------------- Card initialization ----------------
    document.querySelectorAll(SEL.card).forEach(initCard);

    function initCard(card) {
      const form     = card.querySelector(SEL.form);
      const atcBtn   = card.querySelector(SEL.atc);
      const selectEl = form?.querySelector(SEL.select);
      const qtyEl    = form?.querySelector(SEL.qty);
      const priceEl  = card.querySelector(SEL.price);
      const jsonEl   = form?.querySelector(SEL.variantsJSON);
      if (!form || !atcBtn || !selectEl || !jsonEl) return;

      // NEW — remember the original button HTML so we can restore it
      if (!atcBtn.dataset.baseHtml) {
        atcBtn.dataset.baseHtml = atcBtn.innerHTML;
      }

      // NEW — hoist adding flag so syncUIToVariant can see it
      let adding = false;


      let variants = [];
      try { variants = JSON.parse(jsonEl.textContent || "[]"); } catch {}

      function norm(s) { return (s ?? "").toString().trim().toLowerCase(); }
      function to700(url) { return url.replace(/(\.[a-zA-Z0-9]+)(\?.*)?$/, "_700x$1$2"); }

      const mediaLink = card.querySelector(".linked-product__media");
      const imgEl     = mediaLink?.querySelector("img");
      const mediaJSON = form?.querySelector('[data-media-json]');
      let media = [];
      try { media = JSON.parse(mediaJSON?.textContent || "[]"); } catch {}

      function readOptionByIndex(idx) {
        let el = form.querySelector(`[data-index="option${idx}"]`);
        if (el) {
          if (el.matches('select, .single-option-selector')) return el.value;
          const checked = el.querySelector('input[type="radio"]:checked');
          if (checked) return checked.value;
        }
        el = form.querySelector(`select[data-index="option${idx}"], .single-option-selector[data-index="option${idx}"]`);
        if (el) return el.value;
        const radio = form.querySelector(`input[type="radio"][data-index="option${idx}"]:checked`);
        if (radio) return radio.value;

        const opts = Array.from(form.querySelectorAll('input[name^="options["], select[name^="options["]'));
        const groups = [];
        opts.forEach(o => { if (!groups.includes(o.name)) groups.push(o.name); });
        const groupName = groups[idx - 1];
        if (groupName) {
          const inGroup = opts.filter(o => o.name === groupName);
          const selectedRadio = inGroup.find(x => x.tagName === 'INPUT' && x.type === 'radio' && x.checked);
          if (selectedRadio) return selectedRadio.value;
          const sel = inGroup.find(x => x.tagName === 'SELECT');
          if (sel) return sel.value;
        }
        return null;
      }

      function resolveVariant() {
        const o1 = readOptionByIndex(1);
        const o2 = readOptionByIndex(2);
        const o3 = readOptionByIndex(3);
        if (o1 || o2 || o3) {
          const v = variants.find(v =>
            (v.option1 ?? null) === (o1 ?? null) &&
            (v.option2 ?? null) === (o2 ?? null) &&
            (v.option3 ?? null) === (o3 ?? null)
          );
          if (v) return v;
        }
        const id = Number(selectEl.value);
        return variants.find(v => v.id === id) || null;
      }

      function syncUIToVariant(variant) {
        const available = !!(variant && variant.available);

        if (variant && selectEl.value !== String(variant.id)) {
          selectEl.value = String(variant.id);
        }

        if (variant && priceEl) {
          const opt = selectEl.querySelector(`option[value="${variant.id}"]`);
          if (opt && opt.dataset.price) priceEl.innerHTML = opt.dataset.price;
        }

        atcBtn.disabled = !available;

        // NEW — label logic
        if (!available) {
          // Show SOLD OUT whenever this card's current selection is unavailable
          if (atcBtn.innerText.trim() !== "SOLD OUT") {
            atcBtn.innerHTML = "<span>SOLD OUT</span>";
          }
        } else {
          // Revert to original label when available (avoid stomping while adding)
          if (!adding && atcBtn.dataset.baseHtml && atcBtn.innerHTML !== atcBtn.dataset.baseHtml) {
            atcBtn.innerHTML = atcBtn.dataset.baseHtml;
          }
        }
      }


      function updateSizeDisables() {
        let sizeFs = form.querySelector(SEL.sizeFieldset);
        if (!sizeFs) {
          sizeFs = form.querySelector('fieldset.variant-input-wrap[data-index="option1"]')
                || form.querySelector('fieldset.variant-input-wrap');
        }
        if (!sizeFs) return;

        const sizeInputs = Array.from(sizeFs.querySelectorAll('input[type="radio"][data-index^="option"]'));
        if (!sizeInputs.length) return;

        const sizeIndexAttr = sizeFs.getAttribute('data-index')
                            || sizeInputs[0]?.getAttribute('data-index')
                            || 'option1';
        const sizeIdx = Number((sizeIndexAttr.match(/option(\d)/) || [,'1'])[1]);

        const sel1 = readOptionByIndex(1);
        const sel2 = readOptionByIndex(2);
        const sel3 = readOptionByIndex(3);

        const availableSizeValues = new Set();
        variants.forEach(v => {
          if (!v.available) return;
          const okOther =
            (sizeIdx !== 1 ? (sel1 == null || v.option1 === sel1) : true) &&
            (sizeIdx !== 2 ? (sel2 == null || v.option2 === sel2) : true) &&
            (sizeIdx !== 3 ? (sel3 == null || v.option3 === sel3) : true);
          if (!okOther) return;
          const val = (sizeIdx === 1 ? v.option1 : sizeIdx === 2 ? v.option2 : v.option3);
          if (val != null) availableSizeValues.add(String(val));
        });

        sizeInputs.forEach(input => {
          const thisVal = input.value;
          const label = sizeFs.querySelector('label[for="' + input.id + '"]');
          const isAvail = availableSizeValues.has(String(thisVal));
          input.disabled = !isAvail;
          if (label) label.classList.toggle('disabled', !isAvail);
          input.setAttribute('aria-disabled', String(!isAvail));
        });

        const checked = sizeInputs.find(i => i.checked);
        if (checked && checked.disabled) {
          const fallback = sizeInputs.find(i => !i.disabled);
          if (fallback) {
            fallback.checked = true;
            fallback.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }

      function pickMediaForVariant(variant) {
        if (!variant) return null;
        const vmId = variant.featured_media?.id || variant.featured_image?.id;
        if (vmId) {
          const m = media.find(x => String(x.id) === String(vmId));
          if (m?.preview_image?.src) return m.preview_image.src;
        }
        const colorVal = (function () {
          const o1 = readOptionByIndex(1), o2 = readOptionByIndex(2), o3 = readOptionByIndex(3);
          const candidates = [o1, o2, o3].filter(Boolean);
          return candidates.length ? candidates[0] : null;
        })();
        if (colorVal) {
          const key = norm(colorVal);
          const mByAlt = media.find(m => {
            const alt = norm(m.alt || m.preview_image?.alt || "");
            const name = norm(m.preview_image?.src || "");
            return alt.includes(key) || name.includes(key);
          });
          if (mByAlt?.preview_image?.src) return mByAlt.preview_image.src;
        }
        const first = media[0]?.preview_image?.src;
        return first || null;
      }

      function swapThumbTo(src) {
        if (!imgEl || !src) return;
        const httpsSrc = src.startsWith("//") ? ("https:" + src) : src;
        const w352 = httpsSrc.replace(/(\.[a-z0-9]+)(\?.*)?$/i, "_352x$1$2");
        const w700 = httpsSrc.replace(/(\.[a-z0-9]+)(\?.*)?$/i, "_700x$1$2");
        imgEl.removeAttribute("data-src");
        imgEl.removeAttribute("data-srcset");
        imgEl.classList.remove("lazyload", "lazyloading");
        imgEl.src = w700;
        imgEl.srcset = `${w352} 352w, ${w700} 700w`;
        imgEl.sizes = "100vw";
        if (mediaLink) mediaLink.href = httpsSrc;
        try { imgEl.decode?.().catch(()=>{}); } catch {}
        imgEl.loading = "eager";
      }

      function syncImageToVariant(variant) {
        const src = pickMediaForVariant(variant);
        if (src) swapThumbTo(src);
      }

      const initialVariant = resolveVariant();
      syncUIToVariant(initialVariant);
      updateSizeDisables();
      syncImageToVariant(initialVariant);

      form.addEventListener("change", (e) => {
        const el = e.target;
        if (!(el instanceof Element)) return;
        if (el.matches('[data-index^="option"], .single-option-selector, select[name^="options["], input[type="radio"][name^="options["], ' + SEL.select)) {
          updateSizeDisables();
          const v = resolveVariant();
          syncUIToVariant(v);
          syncImageToVariant(v);
        }
      });

      form.addEventListener("click", (e) => {
        const swatchy = e.target.closest('[data-index^="option"], .swatch__item, .variant__button, [data-option], input[type="radio"]');
        if (!swatchy) return;
        queueMicrotask(() => {
          updateSizeDisables();
          const v = resolveVariant();
          syncUIToVariant(v);
          syncImageToVariant(v);
        });
      });

   
      atcBtn.addEventListener("click", async (e) => {
        e.preventDefault();
        if (adding) return;

        const variant = resolveVariant();
        syncUIToVariant(variant);
        if (!variant || !variant.available) return;

        let qty = 1;
        if (qtyEl) {
          const parsed = parseInt(qtyEl.value, 10);
          qty = isNaN(parsed) || parsed <= 0 ? 1 : parsed;
        }

        const prevHTML = atcBtn.innerHTML;
        atcBtn.disabled = true;
        atcBtn.innerHTML = "<span>Adding…</span>";
        adding = true;

        try {
          const res = await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", "Accept": "application/json" },
            body: JSON.stringify({ id: variant.id, quantity: qty })
          });
          if (!res.ok) throw new Error(await res.text());

          if (window.jQuery) {
            const $ = window.jQuery;
            $('body').trigger('added.ajaxProduct', [$(atcBtn)]);
          } else {
            document.dispatchEvent(new CustomEvent("cart:build"));
            document.querySelector('.js-drawer-open-cart,[aria-controls="CartDrawer"]')
              ?.dispatchEvent(new Event("click", { bubbles: true }));
          }

          atcBtn.innerHTML = "<span>Added ✓</span>";
          setTimeout(() => {
            atcBtn.innerHTML = prevHTML;
            syncUIToVariant(resolveVariant());
          }, 900);
        } catch (err) {
          console.warn("[ctl] add to cart error", err);
          atcBtn.innerHTML = "<span>Error</span>";
          setTimeout(() => {
            atcBtn.innerHTML = prevHTML;
            syncUIToVariant(resolveVariant());
          }, 1200);
        } finally {
          adding = false;
        }
      });
    } // initCard

    // ---------------- Proxy color swatches (clone real → above image) ----------------
    document.querySelectorAll("article.linked-product[data-linked-item]").forEach((card) => {
      const imageWrap = card.querySelector(".set-image-wrapper");
      const form = card.querySelector("[data-variant-form]");
      if (!imageWrap || !form) return;

      let colorFieldset =
        form.querySelector('fieldset.variant-input-wrap[name="Color"]') ||
        form.querySelector('fieldset[name="Color"]') ||
        form.querySelector('.swatch--color, .swatch[data-option="Color"], [data-color-swatch], .variant-wrapper--color');

      if (!colorFieldset) {
        const candidates = Array.from(form.querySelectorAll('fieldset.variant-input-wrap'));
        colorFieldset = candidates.find(fs => {
          const nameAttr = (fs.getAttribute("name") || fs.getAttribute("data-name") || "").toLowerCase();
          const hasColorHint =
            nameAttr.includes("color") ||
            fs.matches(".swatch--color, [data-color-swatch], .variant-wrapper--color") ||
            fs.querySelector('[data-swatch], .color-swatch, [style*="background"]');
          const isSize = nameAttr === "size" || (fs.id || "").toLowerCase().includes("size");
          return hasColorHint && !isSize;
        }) || null;
      }
      if (!colorFieldset) return;

      const realWrapper = colorFieldset.closest(".variant-wrapper") || colorFieldset;

      const proxyWrapper = realWrapper.cloneNode(true);
      proxyWrapper.setAttribute("data-proxy-color", "true");
      proxyWrapper.querySelectorAll("[id]").forEach(el => el.removeAttribute("id"));
      proxyWrapper.querySelectorAll("input, select").forEach((el) => {
        el.setAttribute("disabled", "disabled");
        el.setAttribute("tabindex", "-1");
      });
      imageWrap.parentNode.insertBefore(proxyWrapper, imageWrap);

      function normalize(v) { return (v ?? '').toString().trim().toLowerCase(); }

      function collectRealInputs(wrapperEl) {
        const blocks = Array.from(wrapperEl.querySelectorAll('.variant-input, [data-swatch-item]'));
        let inputs = blocks.map(b => b.querySelector('input[type="radio"], select')).filter(Boolean);
        if (!inputs.length) inputs = Array.from(wrapperEl.querySelectorAll('input[type="radio"], select'));
        const map = new Map();
        inputs.forEach(inp => {
          let val = '';
          if (inp.tagName === 'SELECT') {
            val = inp.options[inp.selectedIndex]?.text || inp.value;
          } else {
            const container = inp.closest('.variant-input,[data-swatch-item]');
            val = container?.getAttribute('data-value') || inp.value;
          }
          map.set(normalize(val), inp);
        });
        return map;
      }

      function collectProxyOptions(wrapperEl) {
        const blocks = Array.from(wrapperEl.querySelectorAll('.variant-input, [data-swatch-item]'));
        if (blocks.length) return blocks;
        return Array.from(wrapperEl.querySelectorAll('label'));
      }

      function getOptionLabelEl(container) {
        return container.querySelector('.variant__button-label, label, [data-swatch], .color-swatch') || container;
      }

      const realMap  = collectRealInputs(realWrapper);
      const proxies  = collectProxyOptions(proxyWrapper);

      proxies.forEach((proxyContainer) => {
        const proxyLabel = getOptionLabelEl(proxyContainer);
        proxyLabel.style.cursor = "pointer";

        function readProxyValue() {
          const viaAttr = proxyContainer.getAttribute('data-value');
          if (viaAttr) return viaAttr;
          const input = proxyContainer.querySelector('input[type="radio"], select');
          if (input) {
            if (input.tagName === 'SELECT') {
              return input.options[input.selectedIndex]?.text || input.value;
            }
            return input.value;
          }
          return proxyLabel.textContent;
        }

        proxyLabel.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();

          const raw = readProxyValue();
          const key = normalize(raw);
          const realInput = realMap.get(key);
          if (!realInput) return;

          const realLabel = realWrapper.querySelector('label[for="' + realInput.id + '"]');
          const realDisabled = realInput.disabled || (realLabel && realLabel.classList.contains("disabled"));
          if (realDisabled) return;

          realInput.click();
        });
      });

      function syncProxyState() {
        proxies.forEach((proxyContainer) => {
          const proxyLabel = getOptionLabelEl(proxyContainer);
          const raw = (proxyContainer.getAttribute('data-value')
                    || proxyContainer.querySelector('input[type="radio"], select')?.value
                    || proxyLabel.textContent);
          const key = normalize(raw);
          const realInput = realMap.get(key);
          if (!realInput || !proxyLabel) return;

          const realLabel = realWrapper.querySelector('label[for="' + realInput.id + '"]');
          const isDisabled = realInput.disabled || (realLabel && realLabel.classList.contains("disabled"));
          proxyLabel.classList.toggle("disabled", !!isDisabled);
          proxyLabel.setAttribute("aria-disabled", String(!!isDisabled));

          const isChecked = (realInput.type === "radio" ? realInput.checked : false);
          proxyLabel.classList.toggle("is-selected", !!isChecked);
          proxyLabel.setAttribute("aria-pressed", String(!!isChecked));
        });
      }

      syncProxyState();
      realWrapper.addEventListener("change", syncProxyState);
      realWrapper.addEventListener("click", () => queueMicrotask(syncProxyState));
      new MutationObserver(syncProxyState).observe(realWrapper, { attributes: true, childList: true, subtree: true });
      proxyWrapper.addEventListener("click", () => setTimeout(syncProxyState, 50));
    });

    // ---------------- Color label sync (visible color text) ----------------
    document.querySelectorAll("article.linked-product[data-linked-item]").forEach((card) => {
      const form = card.querySelector("[data-variant-form]");
      if (!form) return;

      const colorInfo = card.querySelector('.variant__label-info[data-color="true"] span[data-option-index]');
      if (!colorInfo) return;

      let colorFieldset =
        form.querySelector('fieldset.variant-input-wrap[name="Color"]') ||
        form.querySelector('fieldset[name="Colour"]') ||
        form.querySelector('.swatch--color, [data-color-swatch], .variant-wrapper--color');
      if (!colorFieldset) return;

      const realInputs = Array.from(colorFieldset.querySelectorAll('input[type="radio"], select'));

      function updateColorLabel() {
        const selectedInput = realInputs.find(i => i.checked) ||
                              (realInputs[0]?.tagName === "SELECT" ? realInputs[0] : null);
        if (!selectedInput) return;

        const selectedValue = selectedInput.tagName === "SELECT"
          ? selectedInput.options[selectedInput.selectedIndex].textContent.trim()
          : selectedInput.value.trim();

        if (selectedValue) {
          colorInfo.textContent = selectedValue;
        }
      }

      updateColorLabel();
      colorFieldset.addEventListener("change", updateColorLabel);

      const proxy = card.querySelector('[data-proxy-color="true"]');
      if (proxy) proxy.addEventListener("click", () => setTimeout(updateColorLabel, 50));
    });

    // =========================================================================
    // NEW: MAIN PRODUCT COLOR → LINKED PRODUCTS SYNC (set color + hide others)
    // =========================================================================
    (function syncLinkedToMainColor() {
      const mainForm = document.querySelector(SEL.mainForm);
      if (!mainForm) return;

      // Find the main product color fieldset
      let mainColorFs =
        mainForm.querySelector(SEL.mainColorFieldsets) ||
        (function () {
          // last-resort heuristic among all fieldsets
          const candidates = Array.from(mainForm.querySelectorAll('fieldset'));
          return candidates.find(fs => {
            const nameAttr = (fs.getAttribute("name") || fs.getAttribute("data-name") || "").toLowerCase();
            const idAttr   = (fs.id || "").toLowerCase();
            return nameAttr.includes("color") || idAttr.includes("color") ||
                   fs.matches(".swatch--color, [data-color-swatch], .variant-wrapper--color");
          }) || null;
        })();

      if (!mainColorFs) return;

      function normalize(s) { return (s ?? "").toString().trim().toLowerCase(); }

      function readMainSelectedColor() {
        const radios = Array.from(mainColorFs.querySelectorAll('input[type="radio"]'));
        const selRadio = radios.find(r => r.checked);
        if (selRadio) return selRadio.value;

        const sel = mainColorFs.querySelector('select');
        if (sel) return sel.options[sel.selectedIndex]?.text || sel.value;

        // Fallback: look for active swatch label text
        const active = mainColorFs.querySelector('.is-selected, [aria-pressed="true"], .active');
        if (active) return active.textContent;
        return null;
      }

      function applyColorToCard(card, colorValue) {
        if (!colorValue) return;
        const want = normalize(colorValue);

        const form = card.querySelector(SEL.form);
        if (!form) return;

        // Real color group inside the card
        let cardColorFs =
          form.querySelector('fieldset.variant-input-wrap[name="Color"]') ||
          form.querySelector('fieldset[name="Colour"]') ||
          form.querySelector('.swatch--color, [data-color-swatch], .variant-wrapper--color');
        if (!cardColorFs) return;

        // 1) Try to select the matching color option in this card
        const inputs = Array.from(cardColorFs.querySelectorAll('input[type="radio"], select'));
        let matched = false;

        // Radios first
        const radios = inputs.filter(i => i.tagName === 'INPUT' && i.type === 'radio');
        for (const r of radios) {
          if (normalize(r.value) === want && !r.disabled) {
            r.click(); // triggers our existing listeners; keeps logic unchanged
            matched = true;
            break;
          }
        }

        // If not radios (or no match), try select
        if (!matched) {
          const sel = inputs.find(i => i.tagName === 'SELECT');
          if (sel) {
            // prefer matching by visible text
            const options = Array.from(sel.options);
            const byText = options.find(o => normalize(o.textContent) === want);
            const byVal  = options.find(o => normalize(o.value) === want);
            const target = byText || byVal;
            if (target) {
              sel.value = target.value;
              sel.dispatchEvent(new Event('change', { bubbles: true }));
              matched = true;
            }
          }
        }

        // 2) Hide all other color options (both real and proxy) if we matched
        if (matched) {
          // Real swatch blocks
          cardColorFs.querySelectorAll('.variant-input, [data-swatch-item], label').forEach(block => {
            const valueAttr = block.getAttribute('data-value');
            const label = block.querySelector('.variant__button-label, label, [data-swatch], .color-swatch') || block;
            const val =
              valueAttr ||
              block.querySelector('input[type="radio"]')?.value ||
              block.querySelector('select')?.value ||
              (label && label.textContent);

            const isMatch = normalize(val) === want;
            // Hide non-matching
            block.style.display = isMatch ? "" : "none";
          });

          // Proxy (above image)
          const proxy = card.querySelector('[data-proxy-color="true"]');
          if (proxy) {
            proxy.querySelectorAll('.variant-input, [data-swatch-item], label').forEach(block => {
              const valueAttr = block.getAttribute('data-value');
              const label = block.querySelector('.variant__button-label, label, [data-swatch], .color-swatch') || block;
              const val =
                valueAttr ||
                block.querySelector('input[type="radio"]')?.value ||
                block.querySelector('select')?.value ||
                (label && label.textContent);

              const isMatch = normalize(val) === want;
             // block.style.display = isMatch ? "" : "none";
            });
          }
        }
      }

      function applyColorToAllLinked(color) {
        document.querySelectorAll(SEL.card).forEach(card => applyColorToCard(card, color));
      }

      // Initial sync on load (use current main color)
      const initialColor = readMainSelectedColor();
      if (initialColor) applyColorToAllLinked(initialColor);

      // React to main color changes
      mainColorFs.addEventListener("change", () => {
        const c = readMainSelectedColor();
        if (c) applyColorToAllLinked(c);
      });
      // Some themes only toggle on click
      mainColorFs.addEventListener("click", () => {
        queueMicrotask(() => {
          const c = readMainSelectedColor();
          if (c) applyColorToAllLinked(c);
        });
      });
    })();
    // =========================================================================
    // End NEW bit
    // =========================================================================

   // ----- SIZE SYNC: main PDP form <-> main (non-.meta) linked card ONLY -----
(function mainCardSizeSync() {
  const SEL = {
    panel: ".complete-the-set-wrapper",
    mainForm: "form.product-single__form",
    sizeFs: 'fieldset[name="Size"], fieldset.variant-input-wrap[name="Size"]',
    // the "main" card in the set is the one WITHOUT .meta
    mainLinkedCard: ".complete-the-set-wrapper article.linked-product:not(.meta)",
    linkedForm: "[data-variant-form]"
  };

  const panel = document.querySelector(SEL.panel);
  // Global shield: if the drawer is open and the click starts inside it,
// stop it before any theme "outside click" handler sees it.

  if (!panel) return;


panel.addEventListener('keydown', (e) => {
  if (!panel.classList.contains('active')) return;
  if (!panel.contains(e.target)) return;
  if (e.key === 'Enter' || e.key === ' ') {
    if (e.target.closest('[data-variant-form], .variant-input-wrap, .variant__button-label')) {
      e.stopPropagation();
    }
  }
}, true);



  // Keep clicks inside the set drawer from bubbling to global "close on outside click"

// what counts as a “variant selector”?
function isVariantSelector(el) {
  return !!(el && el.closest(
    [
      '[data-variant-form]',
      '.variant-input-wrap',
      '.variant__button-label',
      '.color-swatch',
      '.swatch__item',
      '[data-option]',
      'input[type="radio"]',
      'select[name^="options["]',
      '[data-index^="option"]',
      '.size-guide-container',
      '.set-image-wrapper',
      '[data-proxy-color="true"]'
    ].join(',')
  ));
}

let startedInsidePanel = false;
let startedOnVariant   = false;

['pointerdown','mousedown','touchstart'].forEach(evt => {
  document.addEventListener(evt, (e) => {
    if (!panel.classList.contains('active')) {
      startedInsidePanel = false;
      startedOnVariant = false;
      return;
    }
    // where did the interaction START?
    const inside = panel.contains(e.target) || openBtn.contains(e.target);
    startedInsidePanel = inside;
    startedOnVariant   = inside && isVariantSelector(e.target);
  }, true); // capture
});

document.addEventListener('click', (e) => {
  if (!panel.classList.contains('active')) return;

  // where did it END?
  const endInsidePanel = panel.contains(e.target) || openBtn.contains(e.target);
  const endOnVariant   = isVariantSelector(e.target);

  // never close if interaction started/ended inside OR on any variant selector
  if (startedInsidePanel || endInsidePanel || startedOnVariant || endOnVariant) {
    startedInsidePanel = false;
    startedOnVariant = false;
    return;
  }

  // true outside click: close
  panel.classList.remove('active');
}, true); // capture
  const cssEsc = (s) => (window.CSS && CSS.escape ? CSS.escape(String(s)) : String(s).replace(/("|'|\\)/g, "\\$1"));

  // nodes
  const getMainSizeFs = () =>
    document.querySelector(SEL.mainForm)?.querySelector(SEL.sizeFs) || null;

  const getLinkedSizeFs = () => {
    const card = document.querySelector(SEL.mainLinkedCard);
    if (!card) return null;
    const form = card.querySelector(SEL.linkedForm) || card;
    return form.querySelector(SEL.sizeFs) || null;
  };

  // read current selection (literal only)
  function readSelected(fs) {
    if (!fs) return null;
    const r = fs.querySelector('input[type="radio"]:checked');
    if (r) return r.value;
    const s = fs.querySelector("select");
    if (s) return s.value || s.options[s.selectedIndex]?.text || "";
    return null;
  }

  // select exact value in target FS (no normalization)
  function selectExact(fs, literal) {
    if (!fs || literal == null || literal === "") return false;

    // radio
    const r = fs.querySelector(`input[type="radio"][value="${cssEsc(literal)}"]`);
    if (r && !r.disabled && r.getAttribute("aria-disabled") !== "true") {
      r.click(); // trigger theme listeners
      return true;
    }

    // select: try by value, then by visible text
    const sel = fs.querySelector("select");
    if (sel) {
      let opt = Array.from(sel.options).find(o => o.value === literal && !o.disabled);
      if (!opt) opt = Array.from(sel.options).find(o => o.text === literal && !o.disabled);
      if (opt) {
        sel.value = opt.value;
        sel.dispatchEvent(new Event("change", { bubbles: true }));
        return true;
      }
    }
    return false;
  }

  // loop guards
  let fromMain = false;
  let fromLinked = false;

  function pushMainToLinked() {
    if (fromLinked) return;
    const mainFs = getMainSizeFs();
    const linkedFs = getLinkedSizeFs();
    if (!mainFs || !linkedFs) return;
    const v = readSelected(mainFs);
    if (!v) return;
    fromMain = true;
    selectExact(linkedFs, v);
    requestAnimationFrame(() => { fromMain = false; });
  }

  function pushLinkedToMain() {
    if (fromMain) return;
    const mainFs = getMainSizeFs();
    const linkedFs = getLinkedSizeFs();
    if (!mainFs || !linkedFs) return;
    const v = readSelected(linkedFs);
    if (!v) return;
    fromLinked = true;
    selectExact(mainFs, v);
    requestAnimationFrame(() => { fromLinked = false; });
  }

  // Delegate changes: main -> linked
document.addEventListener("change", (e) => {
  const mainFs = getMainSizeFs();
  if (mainFs && mainFs.contains(e.target)) pushMainToLinked();
}, { passive: true });

  document.addEventListener("click", (e) => {
    const mainFs = getMainSizeFs();
    if (mainFs && mainFs.contains(e.target)) queueMicrotask(pushMainToLinked);
  }, { passive: true });

  // Delegate changes: linked (non-.meta) -> main
document.addEventListener("change", (e) => {
  const linkedFs = getLinkedSizeFs();
  if (linkedFs && linkedFs.contains(e.target)) pushLinkedToMain();
}, { passive: true });

  document.addEventListener("click", (e) => {
    const linkedFs = getLinkedSizeFs();
    if (linkedFs && linkedFs.contains(e.target)) queueMicrotask(pushLinkedToMain);
  }, { passive: true });

  // Handle section reloads (delegated listeners persist)
  document.addEventListener("shopify:section:load", () => {
    // optional nudge when panel is open
    if (panel.classList.contains("active")) requestAnimationFrame(pushMainToLinked);
  });

  // Initial nudge once
  requestAnimationFrame(pushMainToLinked);
})();

    
// --- BULLETPROOF DRAWER SHIELD: keep open on variant interactions ---
(function drawerShield() {
  const panel   = document.querySelector(".complete-the-set-wrapper");
  const openBtn = document.querySelector(".complete-the-set-button");
  const closeBtn = document.querySelector(".complete-the-set-wrapper .close");
  if (!panel || !openBtn || !closeBtn) return;

  // What counts as a variant control inside the drawer?
  const SAFE_SELECTORS = [
    '[data-variant-form]',
    '.variant-input-wrap',
    '.variant__button-label',
    '.color-swatch',
    '.swatch__item',
    '[data-option]',
    'input[type="radio"]',
    'select[name^="options["]',
    '[data-index^="option"]',
    '.size-guide-container',
    '.set-image-wrapper',
    '[data-proxy-color="true"]'
  ].join(',');

  // Don’t keep open when user intentionally closes or clicks the Add to Cart for linked card
  function isExplicitCloseTarget(t) {
    return !!(t && (t === closeBtn || t.closest('.complete-the-set-wrapper .close')));
  }
  function isLinkedATC(t) {
    return !!(t && t.closest('.linked-product [data-atc]'));
  }
  function isSafeVariantTarget(t) {
    return !!(t && panel.contains(t) && t.closest(SAFE_SELECTORS));
  }

  // If any handler still manages to remove 'active' right after a safe click, restore it.
  let lastSafeInteractionTs = 0;
  const RESCUE_WINDOW_MS = 500;

  // Blockers: capture phase so we preempt theme/jQuery bubble listeners
  const EVENTS = ['pointerdown','pointerup','mousedown','mouseup','touchstart','touchend','click'];

  EVENTS.forEach(type => {
    document.addEventListener(type, (e) => {
      if (!panel.classList.contains('active')) return;

      const t = e.target;

      // Let explicit close or ATC proceed normally.
      if (isExplicitCloseTarget(t) || isLinkedATC(t)) return;

      // If the event is inside the panel on any variant control, eat propagation only.
      if (isSafeVariantTarget(t)) {
        lastSafeInteractionTs = Date.now();

        // Do NOT preventDefault on touch events — on mobile that cancels the synthesized click,
        // breaking label→radio toggles and anchor navigation. Propagation-stop alone is enough
        // to keep outside-click handlers from closing the drawer.
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      }
    }, true); // capture
  });

  // True outside click → close (but only if interaction neither started nor ended on a safe control)
  // We track where the interaction began.
  let downStartedOnSafe = false;
  ['pointerdown','mousedown','touchstart'].forEach(type => {
    document.addEventListener(type, (e) => {
      if (!panel.classList.contains('active')) { downStartedOnSafe = false; return; }
      const t = e.target;
      downStartedOnSafe = isSafeVariantTarget(t);
    }, true);
  });

  document.addEventListener('click', (e) => {
    if (!panel.classList.contains('active')) return;

    const t = e.target;
    if (isExplicitCloseTarget(t)) return; // allow close button
    if (isSafeVariantTarget(t) || downStartedOnSafe) return; // never treat as outside
    if (panel.contains(t) || openBtn.contains(t)) return;    // inside -> ignore

    // true outside click: close
    panel.classList.remove('active');
  }, true);

  // Rescue: if something else removes .active right after a safe interaction, put it back.
  const mo = new MutationObserver(() => {
    if (!panel.classList.contains('active')) {
      const since = Date.now() - lastSafeInteractionTs;
      if (since >= 0 && since <= RESCUE_WINDOW_MS) {
        // restore without scroll jumps
        panel.classList.add('active');
      }
    }
  });
  mo.observe(panel, { attributes: true, attributeFilter: ['class'] });
})();


  }); // DOMContentLoaded

// =============================================================================
// GALLERY CONTROLLER — unified state for Color × Undergarment × Style-With Set
// -----------------------------------------------------------------------------
// Consolidates two legacy handlers:
//   - dyn-anchor injector (was assets/custom.js line 545-750, removed)
//   - setGallerySwitching (was below, replaced)
// Single state object eliminates race between handlers on .style-with__link
// click and provides a clean extension point for 2-axis Undergarment filter.
// See _projects/natalie-rolt/CUSTOMIZATIONS.md for spec.
// =============================================================================
(function GalleryController() {
  const GALLERY_SEL = '.photoswipe-gallery';
  const DYN_ID_PREFIX = 'dyn-';

  const state = {
    color: null,
    undergarment: null,
    styleSetHandle: null, // null = no Style-With set active
  };

  // ---- utils ----
  // handleize: dash-separator format ("Ice Blue" → "ice-blue"). For matching
  // Shopify product handles (e.g., linked_product.handle), which canonically
  // use dashes.
  const handleize = (s) =>
    (s ?? '')
      .toString()
      .trim()
      .toLowerCase()
      .replace(/['"_]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

  // tokenize: spaceless lowercase alphanumeric ("Ice Blue" → "iceblue"). For
  // matching alt-text Color/Undergarment tokens, which Liquid emits via
  // `downcase | replace: ' ', ''` (no separator). Use this for all data-color
  // and data-undergarment comparisons.
  const tokenize = (s) =>
    (s ?? '')
      .toString()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '');

  const norm = (s) => (s ?? '').toString().trim().toLowerCase();

  function parseJSONFrom(el, selector) {
    try {
      const node = el.querySelector(selector);
      return node ? JSON.parse(node.textContent || '[]') : [];
    } catch { return []; }
  }

  function toSized(src, size) {
    const https = src.startsWith('//') ? 'https:' + src : src;
    return https.replace(/(\.[a-z0-9]+)(\?.*)?$/i, `_${size}$1$2`);
  }

  function anchorColorHandle(a) {
    const img = a.querySelector('img');
    const fromAlt = img?.getAttribute('alt');
    const fromData = a.getAttribute('data-value') || a.getAttribute('data-color');
    return handleize(fromAlt || fromData || '');
  }

  // ---- state sync ----
  function readSelectedOption(form, ...names) {
    const lcNames = names.map(n => n.toLowerCase());
    const fs = Array.from(form.querySelectorAll('fieldset')).find((fs) => {
      const name = (fs.getAttribute('name') || fs.getAttribute('data-name') || '').toLowerCase();
      return lcNames.includes(name);
    });
    if (!fs) return null;
    const r = fs.querySelector('input[type="radio"]:checked');
    if (r) return r.value;
    const sel = fs.querySelector('select');
    if (sel) return sel.options[sel.selectedIndex]?.text || sel.value;
    const active = fs.querySelector('.is-selected, [aria-pressed="true"], .active');
    if (active) return active.textContent;
    return null;
  }

  function syncStateFromForm() {
    const form = document.querySelector('form.product-single__form');
    if (!form) return;
    state.color = readSelectedOption(form, 'Color', 'Colour');
    // v1: native UG fieldset (option named "Lace Set" per 2026-06-30 pivot,
    // back-compat "Undergarment" untuk legacy products). v2: pseudo-UG picker
    // writes window.__pseudoUgValue (matching-undergarment.js). Fallback chain
    // ensures both arch coexist without v2 breaking v1 products and vice versa.
    state.undergarment = readSelectedOption(form, 'Lace Set', 'Undergarment') || window.__pseudoUgValue || null;
  }

  // Sync styleSetHandle dari DOM .style-with__link.active. Liquid render
  // `.active` ke link pertama via `{% if forloop.first %} active{% endif %}`.
  // Tanpa sync ini, init state.styleSetHandle=null padahal UI tampak set
  // mode aktif → user lihat gallery core (bukan set images yang match).
  // Dipanggil SEKALI di init + setelah shopify:section:load (NOT on form
  // change / ug:change — state.styleSetHandle dikelola handleStyleWithClick
  // sebagai source of truth setelah user interaksi).
  function syncStyleSetFromDOM() {
    const active = document.querySelector('.style-with__link.active');
    state.styleSetHandle = active ? (active.dataset.product || null) : null;
  }

  // Read Color option values in position order from the variant fieldset radios.
  // Used by applyState() fallback: when selected color has no tagged media, pick
  // the first color option in order that DOES have media, so gallery stays
  // populated instead of blank. Position order = DOM order of radio inputs =
  // Shopify option value order (Impulse renders via variant-button.liquid loop).
  function getColorOptionValues() {
    const form = document.querySelector('form.product-single__form');
    if (!form) return [];
    const fs = Array.from(form.querySelectorAll('fieldset')).find(el => {
      const name = (el.getAttribute('name') || el.getAttribute('data-name') || '').toLowerCase();
      return name === 'color' || name === 'colour';
    });
    if (!fs) return [];
    return Array.from(fs.querySelectorAll('input[type="radio"]')).map(r => r.value);
  }

  // ---- apply: filter anchors based on state ----
  // Filter rules:
  //   - Style-With Set mode (setH set): show only Style-With anchors matching
  //     handle + color, or the injected dyn-anchor for that handle. Hide core.
  //   - Core mode (no setH): show core anchors based on data-color/data-undergarment
  //     parsed from media.alt by Liquid. If 3-seg matches exist for current
  //     (color × undergarment), show ONLY those (precise match). Else fall back
  //     to showing any anchor matching current color (covers 2-seg media like
  //     EvangelineGown_White).
  // -----------------------------------------------------------------------------
  function applyState() {
    const gallery = document.querySelector(GALLERY_SEL);
    if (!gallery) return;

    const anchors = Array.from(gallery.querySelectorAll('.product-image-link'));
    const videos = Array.from(gallery.querySelectorAll('.product-video'));

    // Color/Undergarment use tokenize (spaceless) to match Liquid alt-parse
    // (data-color="iceblue", data-undergarment="espresso"). Style-With set
    // handle continues to use handleize (dashed) since it matches Shopify
    // product handle canonical form.
    const colorT = tokenize(state.color);
    const ugT = tokenize(state.undergarment);
    const setH = state.styleSetHandle;

    // Color fallback resolver (added 2026-09-01): kalau selected color tidak
    // punya anchor tagged sama sekali (mis. Monika Mini colors Lemon/Turquoise/
    // Espresso — merchant belum unggah image untuk color tsb), fallback ke
    // color option pertama di position order yang punya anchor tagged. Cegah
    // gallery blank saat pilih color tanpa media dedicated.
    //
    // Kalau tidak ada color option apa pun yang punya anchor (semua media
    // untagged), effectiveColorT stays as requested colorT — line ~1141/~1163
    // fallback (`!ac`) tetap show untagged anchors as-is (existing behavior).
    //
    // Guarded by `!setH` — Style-With Set mode punya branch sendiri, tidak
    // terpengaruh. UG state (`ugT`) juga unchanged — fallback cuma soal color.
    const anchorHasTaggedColor = (a, t) => {
      if (a.dataset.styleSet === 'true') return false;
      if (a.id && a.id.startsWith(DYN_ID_PREFIX)) return false;
      return tokenize(a.dataset.color || '') === t;
    };

    let effectiveColorT = colorT;
    if (!setH && colorT) {
      const colorHasAnchor = anchors.some(a => anchorHasTaggedColor(a, colorT));
      if (!colorHasAnchor) {
        const optionValues = getColorOptionValues();
        for (const val of optionValues) {
          const t = tokenize(val);
          if (!t || t === colorT) continue;
          if (anchors.some(a => anchorHasTaggedColor(a, t))) {
            effectiveColorT = t;
            break;
          }
        }
      }
    }

    // In core mode, probe whether any anchor matches the EXACT current state
    // (color × ug, including ug="" when picker not selected). If a match
    // exists, restrict visibility to those anchors only; else fall back to
    // broader color-only matching so 2-seg-only media still surface for
    // products without 3-seg coverage.
    //
    // Note: name kept generic — match can be 2-seg (au="" when ugT="") or
    // 3-seg (au="white" when ugT="white"). Guard `&& ugT` removed 2026-06-25
    // (v2.1.1) — was causing 3-seg photos to leak through fallback when
    // picker had no UG selected (full 3-seg-set merchants).
    // Uses effectiveColorT (may differ from colorT via 2026-09-01 fallback).
    let hasExactStateMatch = false;
    if (!setH && effectiveColorT) {
      hasExactStateMatch = anchors.some(a => {
        if (a.dataset.styleSet === 'true') return false;
        if (a.id && a.id.startsWith(DYN_ID_PREFIX)) return false;
        const ac = tokenize(a.dataset.color || '');
        const au = tokenize(a.dataset.undergarment || '');
        return ac === effectiveColorT && au === ugT;
      });
    }

    anchors.forEach(a => {
      const isSet = a.dataset.styleSet === 'true';
      const isDyn = a.id && a.id.startsWith(DYN_ID_PREFIX);

      let show = false;

      if (setH) {
        // Style-With set mode overrides core gallery
        if (isDyn) {
          show = a.dataset.product === setH;
        } else if (isSet) {
          const setMatches = a.getAttribute('data-set-handle') === setH;
          const aColor = anchorColorHandle(a);
          const colorH = handleize(state.color);
          const colorMatches = !colorH || aColor === colorH || aColor.includes(colorH);
          show = setMatches && colorMatches;
        } else {
          show = false;
        }
      } else if (!isSet && !isDyn) {
        // Core mode: filter by data-color + data-undergarment from alt parse.
        // Uses effectiveColorT — may differ from colorT via 2026-09-01 color
        // fallback (selected color without tagged media → show first available
        // color's media instead of blank gallery).
        const ac = tokenize(a.dataset.color || '');
        const au = tokenize(a.dataset.undergarment || '');

        if (effectiveColorT && ac && ac !== effectiveColorT) {
          show = false; // color mismatch
        } else if (hasExactStateMatch) {
          // Precise mode: only anchors matching exact (color × ug) state.
          // When ugT="" this filters to 2-seg media (au=""); when ugT="white"
          // filters to 3-seg media (au="white").
          show = au === ugT;
        } else {
          // Fallback mode: any color-matching anchor (covers media set without
          // exact state match — e.g. only 3-seg photos exist but UG=null).
          show = !effectiveColorT || !ac || ac === effectiveColorT;
        }
      }

      a.style.display = show ? '' : 'none';
    });

    // Videos follow core-mode visibility (same filter as core anchors)
    videos.forEach(v => {
      if (setH) {
        v.style.display = 'none';
        v.pause?.();
        return;
      }
      const ac = tokenize(v.getAttribute('data-color') || v.getAttribute('data-value') || '');
      const au = tokenize(v.getAttribute('data-undergarment') || '');
      let show;
      if (effectiveColorT && ac && ac !== effectiveColorT) {
        show = false;
      } else if (hasExactStateMatch) {
        show = au === ugT;
      } else {
        show = !effectiveColorT || !ac || ac === effectiveColorT;
      }
      v.style.display = show ? '' : 'none';
      if (show && v.paused) v.play?.();
      else v.pause?.();
    });

    // Reindex visible anchors for PhotoSwipe
    const visible = anchors.filter(a => a.style.display !== 'none');
    visible.forEach((el, i) => { el.dataset.index = i; });
    if (window.pswpLightbox?.refresh) window.pswpLightbox.refresh();
  }

  // ---- dyn-anchor fallback (for linked products without pre-rendered media) ----
  function readLinkedOptions(form) {
    const readOpt = (idx) => {
      const sel = form.querySelector(`select[data-index="option${idx}"], .single-option-selector[data-index="option${idx}"]`);
      if (sel) return sel.value;
      const radio = form.querySelector(`input[type="radio"][data-index="option${idx}"]:checked`);
      if (radio) return radio.value;
      return null;
    };
    return [readOpt(1), readOpt(2), readOpt(3)];
  }

  function pickVariant(variants, form, preferColor) {
    const [o1, o2, o3] = readLinkedOptions(form);
    const exact = variants.find(v =>
      (o1 == null || v.option1 === o1) &&
      (o2 == null || v.option2 === o2) &&
      (o3 == null || v.option3 === o3)
    );
    if (exact && exact.available) return exact;
    if (preferColor) {
      const key = norm(preferColor);
      const colorMatchAvail = variants.find(v =>
        v.available && [v.option1, v.option2, v.option3].some(opt => norm(opt) === key)
      );
      if (colorMatchAvail) return colorMatchAvail;
      const colorMatchAny = variants.find(v =>
        [v.option1, v.option2, v.option3].some(opt => norm(opt) === key)
      );
      if (colorMatchAny) return colorMatchAny;
    }
    return variants.find(v => v.available) || variants[0] || null;
  }

  function pickVariantImageSrc(variant, media, preferColor) {
    if (!media || !media.length) return null;
    const vmId = variant?.featured_media?.id || variant?.featured_image?.id;
    if (vmId) {
      const m = media.find(x => String(x.id) === String(vmId));
      const src = m?.preview_image?.src || m?.src;
      if (src) return src;
    }
    if (preferColor) {
      const key = norm(preferColor);
      const byColor = media.find(m => {
        const alt = norm(m.alt || m.preview_image?.alt || '');
        const name = norm(m.preview_image?.src || m.src || '');
        return alt.includes(key) || name.includes(key);
      });
      const src = byColor?.preview_image?.src || byColor?.src;
      if (src) return src;
    }
    const img = media.find(m => (m.media_type || m.type) === 'image' || m.preview_image?.src || m.src);
    return img?.preview_image?.src || img?.src || null;
  }

  function injectDynAnchor(gallery, handle) {
    const linkedCard = document.querySelector(`article.linked-product[data-linked-item][data-product="${handle}"]`)
                    || document.getElementById(`linked-${handle}`);
    if (!linkedCard) return;
    const form = linkedCard.querySelector('[data-variant-form]');
    if (!form) return;

    const variants = parseJSONFrom(form, '[data-variants-json]');
    const media    = parseJSONFrom(form, '[data-media-json]');
    if (!variants.length || !media.length) return;

    const variant = pickVariant(variants, form, state.color);
    const imgSrc  = pickVariantImageSrc(variant, media, state.color);
    if (!imgSrc) return;

    const dynId = DYN_ID_PREFIX + handle;
    let a = gallery.querySelector(`#${dynId}`);
    if (!a) {
      a = document.createElement('a');
      a.id = dynId;
      a.className = 'product-image-link';
      const img = document.createElement('img');
      img.className = 'product-image';
      a.appendChild(img);
      gallery.appendChild(a);
    }

    const img = a.querySelector('img');
    a.href = toSized(imgSrc, 'master');
    a.setAttribute('data-pswp-width', '1200');
    a.setAttribute('data-pswp-height', '1200');
    a.setAttribute('data-pswp-src', toSized(imgSrc, '1200x1200'));
    a.dataset.product = handle;
    const colorToken = norm(
      [variant?.option1, variant?.option2, variant?.option3].find(Boolean) || state.color || ''
    );
    if (colorToken) a.dataset.value = colorToken;

    img.alt = variant?.title || handle;
    img.src = toSized(imgSrc, '1200x1200');
  }

  // ---- click handler: Style-With link ----
  function handleStyleWithClick(e) {
    const trigger = e.target.closest('.style-with__link');
    if (!trigger) return;
    e.preventDefault();

    const handle = trigger.dataset.product || '';
    if (!handle) return;

    // Toggle: clicking active link clears the set
    if (state.styleSetHandle === handle) {
      state.styleSetHandle = null;
      document.querySelectorAll('.style-with__link').forEach(a => a.classList.remove('active'));
      applyState();
      return;
    }

    state.styleSetHandle = handle;

    // Fallback: inject dyn-anchor if no pre-rendered images exist for this handle
    const gallery = document.querySelector(GALLERY_SEL);
    if (gallery) {
      const hasPreRendered = !!gallery.querySelector(`[data-style-set="true"][data-set-handle="${handle}"]`);
      if (!hasPreRendered) injectDynAnchor(gallery, handle);
    }

    document.querySelectorAll('.style-with__link').forEach(a => a.classList.remove('active'));
    trigger.classList.add('active');
    applyState();
  }

  // ---- wiring ----
  function wireFormListeners() {
    const form = document.querySelector('form.product-single__form');
    if (!form) return;

    const colorFs = Array.from(form.querySelectorAll('fieldset')).find(fs => {
      const name = (fs.getAttribute('name') || '').toLowerCase();
      return name === 'color' || name === 'colour';
    });
    if (colorFs && !colorFs.dataset.galleryWired) {
      colorFs.dataset.galleryWired = '1';
      const onChange = () => { syncStateFromForm(); applyState(); };
      colorFs.addEventListener('change', onChange);
      colorFs.addEventListener('click', () => queueMicrotask(onChange));
    }

    const ugFs = form.querySelector('fieldset[data-undergarment-fieldset]')
               || Array.from(form.querySelectorAll('fieldset')).find(fs => {
                    const name = (fs.getAttribute('name') || '').toLowerCase();
                    return name === 'undergarment' || name === 'lace set';
                  });
    if (ugFs && !ugFs.dataset.galleryWired) {
      ugFs.dataset.galleryWired = '1';
      const onChange = () => { syncStateFromForm(); applyState(); };
      ugFs.addEventListener('change', onChange);
      ugFs.addEventListener('click', () => queueMicrotask(onChange));
    }
  }

  function init() {
    syncStateFromForm();
    syncStyleSetFromDOM();
    wireFormListeners();
    document.addEventListener('click', handleStyleWithClick);
    document.addEventListener('shopify:section:load', () => {
      syncStateFromForm();
      syncStyleSetFromDOM();
      wireFormListeners();
      applyState();
    });
    // v2: matching-undergarment.js dispatches 'ug:change' on form when
    // pseudo-UG selection changes. Re-sync + re-apply.
    document.addEventListener('ug:change', () => { syncStateFromForm(); applyState(); }, true);
    // Style-With color filter dispatches 'style-with:cleared' when all
    // linked entries are hidden by main color. Re-read active state (all
    // links cleared) → styleSetHandle=null → gallery reverts to core mode.
    document.addEventListener('style-with:cleared', () => { syncStyleSetFromDOM(); applyState(); });
    applyState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


})();

// =============================================================================
// STYLE-WITH COLOR FILTER — hide linked entries when main product color
// doesn't exist as an option value on the linked product.
// -----------------------------------------------------------------------------
// - data-colors on .style-with__link is CSV of tokenized color values (from
//   Liquid). Empty = linked product has no Color option → always show.
// - On main color change: hide non-matching links; if .active becomes hidden,
//   auto-shift to first visible link (triggers click so gallery re-syncs).
// - If ALL links hidden: clear all .active + show .style-with__empty message
//   + clear GalleryController's styleSetHandle so gallery reverts to core
//   color-only filter (via .active=none read by syncStyleSetFromDOM).
// See _projects/natalie-rolt/CUSTOMIZATIONS.md.
// =============================================================================
(function StyleWithColorFilter() {
  const MAIN_FORM_SEL = 'form.product-single__form';
  const LINK_SEL = '.style-with__link';
  const EMPTY_SEL = '.style-with__empty';

  const tokenize = (s) => (s ?? '').toString().toLowerCase().replace(/[^a-z0-9]+/g, '');

  function readMainColor(form) {
    const fs = Array.from(form.querySelectorAll('fieldset')).find(f => {
      const n = (f.getAttribute('name') || f.getAttribute('data-name') || '').toLowerCase();
      return n === 'color' || n === 'colour';
    });
    if (!fs) return null;
    const checked = fs.querySelector('input[type="radio"]:checked');
    if (checked) return checked.value;
    const sel = fs.querySelector('select');
    if (sel) return sel.options[sel.selectedIndex]?.text || sel.value;
    return null;
  }

  function applyFilter() {
    const form = document.querySelector(MAIN_FORM_SEL);
    if (!form) return;

    const mainColor = readMainColor(form);
    const wanted = tokenize(mainColor);

    const links = Array.from(document.querySelectorAll(LINK_SEL));
    if (!links.length) return;

    let visibleLinks = [];
    let activeVisible = null;

    links.forEach(link => {
      const raw = link.getAttribute('data-colors') || '';
      const colors = raw.split(',').filter(Boolean);
      // Empty data-colors = linked product has no Color option → always show
      const show = colors.length === 0 || !wanted || colors.includes(wanted);
      const item = link.closest('.style-with__item') || link;
      item.style.display = show ? '' : 'none';
      if (show) {
        visibleLinks.push(link);
        if (link.classList.contains('active')) activeVisible = link;
      }
    });

    const emptyEl = document.querySelector(EMPTY_SEL);

    if (visibleLinks.length === 0) {
      // All hidden: clear active, show message, revert gallery to core mode
      links.forEach(a => a.classList.remove('active'));
      if (emptyEl) emptyEl.hidden = false;
      document.dispatchEvent(new CustomEvent('style-with:cleared'));
      return;
    }

    if (emptyEl) emptyEl.hidden = true;

    if (!activeVisible) {
      // Active link is hidden or none active → click first visible to
      // re-sync gallery (GalleryController listens for click on .style-with__link).
      links.forEach(a => a.classList.remove('active'));
      visibleLinks[0].click();
    }
  }

  function wire() {
    const form = document.querySelector(MAIN_FORM_SEL);
    if (!form) return;

    const colorFs = Array.from(form.querySelectorAll('fieldset')).find(f => {
      const n = (f.getAttribute('name') || '').toLowerCase();
      return n === 'color' || n === 'colour';
    });
    if (!colorFs || colorFs.dataset.styleWithFilterWired) return;
    colorFs.dataset.styleWithFilterWired = '1';

    const onChange = () => applyFilter();
    colorFs.addEventListener('change', onChange);
    colorFs.addEventListener('click', () => queueMicrotask(onChange));
  }

  function init() {
    wire();
    applyFilter();
    document.addEventListener('shopify:section:load', () => {
      wire();
      applyFilter();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/*
# =============================================================================
# END — COMPLETE THE SET / LINKED PRODUCTS BUNDLED SCRIPT
# =============================================================================
*/
